import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SubscriptionItemResponseDto } from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import { StatusType } from 'commons/types';
import { getSubscriptionsAction, SubscriptionsSelector } from '../../redux';

interface Attributes {
  status: StatusType;
  items: SubscriptionItemResponseDto[];
  hasSubscriptions: boolean;
  fetchSubscriptions: () => void;
}

export function useOrderSubscriptionsByOrder(orderId?: string): Attributes {
  const dispatch = useAppDispatch();

  const status = useSelector(SubscriptionsSelector.subscriptionsListStatus);
  const items = useSelector(SubscriptionsSelector.subscriptionsItems);
  const hasSubscriptions = useSelector(SubscriptionsSelector.hasSubscriptions);

  const fetchSubscriptions = useCallback(() => {
    if (!orderId) return;
    dispatch(getSubscriptionsAction({ orderId }));
  }, [dispatch, orderId]);

  return {
    status,
    items,
    hasSubscriptions,
    fetchSubscriptions,
  };
}
